var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderInspect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.02,
    height: 22.59,
    viewBox: "0 0 22.02 22.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder-inspect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-inspect"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_86",
    "data-name": "Capa 86"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,17.3a5.1,5.1,0,1,1,5.1,5.1A5.12,5.12,0,0,1,10.1,17.3Zm.7,0a4.4,4.4,0,1,0,4.4-4.4A4.44,4.44,0,0,0,10.8,17.3Z",
    transform: "translate(-1.05 -0.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,22.8l-1-1a.35.35,0,0,1,.5-.5l1,1a.45.45,0,0,1,0,.5.37.37,0,0,1-.3.1C20.3,22.9,20.3,22.9,20.2,22.8Z",
    transform: "translate(-1.05 -0.81)",
    stroke: "{props.color}",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_88",
    "data-name": "Capa 88"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,14.8v-6C1.3,3.4,3.6,1.1,9,1.1h5a.68.68,0,0,1,.7.7.68.68,0,0,1-.7.7H9c-4.6,0-6.2,1.6-6.2,6.2v6C2.8,19.4,4.4,21,9,21a.7.7,0,1,1,0,1.4C3.6,22.5,1.3,20.2,1.3,14.8Zm19.9-2v-3A.86.86,0,0,1,22,9a.68.68,0,0,1,.7.7v3a.68.68,0,0,1-.7.7A.64.64,0,0,1,21.2,12.8Z",
    transform: "translate(-1.05 -0.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,10.5c-3.4,0-4.7-1.3-4.7-4.7v-4a.75.75,0,0,1,.5-.7.78.78,0,0,1,.8.2l8,8a.78.78,0,0,1,0,1.1.76.76,0,0,1-.5.2ZM14.7,5.8c0,2.6.7,3.2,3.3,3.2h2.2L14.8,3.6Z",
    transform: "translate(-1.05 -0.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.05 -0.81)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.05 -0.81)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderInspect);
export default __webpack_public_path__ + "static/media/folder-inspect.2405da68b60e3e00b4024e1dd770c054.svg";
export { ForwardRef as ReactComponent };